import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Подписывается на канал палитры и перезагружает страницу при смене статуса,
// чтобы показать распознанные цвета сразу после окончания парсинга.
export default class extends Controller {
  static values = { id: Number, state: String }

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "Am::PaletteChannel", am_palette_id: this.idValue },
      {
        received: (data) => this.handleMessage(data)
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleMessage(data) {
    if (data.type !== "status_changed") return

    if (data.error && window.Toast) {
      window.Toast.error(data.error)
    }

    if (data.status !== this.stateValue) {
      window.location.reload()
    }
  }
}
